var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-screen" },
    [
      _c("div", { staticClass: "form-info" }, [
        _c(
          "div",
          {
            staticClass: "form-row fl",
            staticStyle: { margin: "0", width: "auto", clear: "none" }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("swb-file-upload", {
                  staticClass: "mt5 fl",
                  attrs: {
                    fileGroup: "comStaff.import",
                    onBeforeUpload: _vm.onBeforeUpload,
                    onProgress: _vm.onProgress,
                    onDone: _vm.onUploadDone,
                    multipleFile: false
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "swb-btn swb-btn-link  fr ml10 mt10",
            on: { click: _vm.downloadTemplate }
          },
          [_vm._v("下载导入模板")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-row fr",
            staticStyle: { margin: "0", width: "auto", clear: "none" }
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.comName || ""))])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "deviceImpInfoTable",
              staticClass: "thin",
              staticStyle: { width: "100%", "font-size": "12px" },
              attrs: { data: _vm.pageComImpInfoList, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "员工姓名",
                  width: "120",
                  "class-name": "required"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        !rows.row.validateInfo.name.validateOk
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.name,
                                  expression: "rows.row.name"
                                }
                              ],
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%"
                              },
                              attrs: {
                                type: "text",
                                title: rows.row.validateInfo.name.errorMsg
                              },
                              domProps: { value: rows.row.name },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "name",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.name,
                                  expression: "rows.row.name"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { type: "text" },
                              domProps: { value: rows.row.name },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "name",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "员工编号", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        !rows.row.validateInfo.no.validateOk
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.no,
                                  expression: "rows.row.no"
                                }
                              ],
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%"
                              },
                              attrs: {
                                type: "text",
                                title: rows.row.validateInfo.no.errorMsg
                              },
                              domProps: { value: rows.row.no },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(rows.row, "no", $event.target.value)
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.no,
                                  expression: "rows.row.no"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { type: "text" },
                              domProps: { value: rows.row.no },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(rows.row, "no", $event.target.value)
                                }
                              }
                            })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "no", label: "岗位编码", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        !rows.row.validateInfo.roleCode.validateOk
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.roleCode,
                                  expression: "rows.row.roleCode"
                                }
                              ],
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%"
                              },
                              attrs: {
                                type: "text",
                                title: rows.row.validateInfo.roleCode.errorMsg
                              },
                              domProps: { value: rows.row.roleCode },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "roleCode",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.roleCode,
                                  expression: "rows.row.roleCode"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { type: "text" },
                              domProps: { value: rows.row.roleCode },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "roleCode",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "phoneNo",
                  label: "用户手机",
                  width: "100",
                  "class-name": "required"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        !rows.row.validateInfo.phoneNo.validateOk
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.phoneNo,
                                  expression: "rows.row.phoneNo"
                                }
                              ],
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%"
                              },
                              attrs: {
                                type: "text",
                                title: rows.row.validateInfo.phoneNo.errorMsg
                              },
                              domProps: { value: rows.row.phoneNo },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "phoneNo",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.phoneNo,
                                  expression: "rows.row.phoneNo"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { type: "text" },
                              domProps: { value: rows.row.phoneNo },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "phoneNo",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "contactTel", label: "联系电话", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        !rows.row.validateInfo.contactTel.validateOk
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.contactTel,
                                  expression: "rows.row.contactTel"
                                }
                              ],
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%"
                              },
                              attrs: {
                                type: "text",
                                title: rows.row.validateInfo.contactTel.errorMsg
                              },
                              domProps: { value: rows.row.contactTel },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "contactTel",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.contactTel,
                                  expression: "rows.row.contactTel"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { type: "text" },
                              domProps: { value: rows.row.contactTel },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "contactTel",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "contactEmail",
                  label: "联系邮箱",
                  width: "170"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        !rows.row.validateInfo.contactEmail.validateOk
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.contactEmail,
                                  expression: "rows.row.contactEmail"
                                }
                              ],
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%"
                              },
                              attrs: {
                                type: "text",
                                title:
                                  rows.row.validateInfo.contactEmail.errorMsg
                              },
                              domProps: { value: rows.row.contactEmail },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "contactEmail",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.contactEmail,
                                  expression: "rows.row.contactEmail"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { type: "text" },
                              domProps: { value: rows.row.contactEmail },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "contactEmail",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "idCertNo", label: "身份证号", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        !rows.row.validateInfo.idCertNo.validateOk
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.idCertNo,
                                  expression: "rows.row.idCertNo"
                                }
                              ],
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%"
                              },
                              attrs: {
                                type: "text",
                                title: rows.row.validateInfo.idCertNo.errorMsg
                              },
                              domProps: { value: rows.row.idCertNo },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "idCertNo",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: rows.row.idCertNo,
                                  expression: "rows.row.idCertNo"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: { type: "text" },
                              domProps: { value: rows.row.idCertNo },
                              on: {
                                change: _vm.commonChangeEvent,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    rows.row,
                                    "idCertNo",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "enrollDate",
                  label: "入职时间",
                  align: "center",
                  width: "200"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetime",
                            placeholder: "选择日期时间"
                          },
                          model: {
                            value: rows.row.enrollDate,
                            callback: function($$v) {
                              _vm.$set(rows.row, "enrollDate", $$v)
                            },
                            expression: "rows.row.enrollDate"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "memo", label: "描述", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("el-input", {
                          staticClass: "width-1-5x bottom-line",
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            placeholder: "请输入描述",
                            maxlength: 120
                          },
                          model: {
                            value: rows.row.memo,
                            callback: function($$v) {
                              _vm.$set(rows.row, "memo", $$v)
                            },
                            expression: "rows.row.memo"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "memo",
                  label: "操作",
                  align: "left",
                  width: "60"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.removeRow(rows.$index)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.totalCount > 0
        ? _c("el-pagination", {
            staticClass: "mt5",
            attrs: {
              background: "",
              "page-size": _vm.pageSize,
              "page-sizes": _vm.pageSizes,
              "current-page": _vm.pageNumber,
              total: _vm.totalCount,
              layout: "prev, pager, next, jumper, sizes, total"
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("员工信息文件")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("当前导入公司：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cc42a00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cc42a00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ComStaffImpCheck.vue
// module id = 2246
// module chunks = 0